import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import Proposal from "@/models/Proposal/Proposal";
import map from "lodash/map";

export default class PaymentTerm extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/payment-term';

    /**
     *
     * @type {string}
     */
    static entity = 'paymentTerm';

    static fields() {
		return {
			id: this.number(null).nullable(),
			payment_amount: this.number(null).nullable(),
			due_date: this.attr(null),
			user_id: this.number(null).nullable(),
			last_reminder: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			proposal_id: this.number(null).nullable(),
            user: this.belongsTo(User, 'user_id'),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
		}
	}

    /**
     *
     * @param proposalId
     * @returns {*}
     */
    static loadByProposal(proposalId){
        return this.api()
            .where('proposal_id', proposalId)
            .limit(0)
            .get(true);
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    destroy(){
        return this.api().delete();
    }

    /**
     *
     * @param terms
     * @param totalPaid
     * @returns {*}
     */
    static addPaidAmount(terms, totalPaid) {

        terms.forEach((term) => {
            if (term.payment_amount < totalPaid) {
                term.paid_amount = term.payment_amount;
                totalPaid = totalPaid - term.payment_amount;
            } else {
                term.paid_amount = totalPaid.toFixed(2);
                totalPaid = 0;
            }
        });

        return terms;
    }

    Proposal() {
        return this.getRelated('proposal')
    }

    static formatExport(requests = [])
    {
        return map(requests, request => {
            return {
                'Voorstel': request.proposal_id,
                'Dossier': request.proposal.dossier_id,
                'Totaalbedrag': request.payment_amount,
                'Vervaldatum': request.due_date,
                'Medewerker': request.user ? request.user.name : '',
            }
        });
    }
}
